import { MouseEvent } from 'react';

import { Svg } from './styles';

interface ArrowBackProps {
  className?: string;
  style?: Record<string, unknown>;
  onClick?: (e: MouseEvent) => void;
  color?: string;
  borderColor?: string;
  opacity?: number;
  height?: string | number;
  width?: string | number;
  shadow?: boolean;
  strokeWidth?: string;
  testId?: string;
  visibility?: string;
}

export const ArrowBack = ({
  className,
  style,
  borderColor,
  opacity,
  height = '24',
  width = '24',
  shadow = false,
  testId,
  visibility = '',
  color = '#14BCFF',
  onClick,
}: ArrowBackProps) => (
  <Svg
    visibility={visibility}
    className={className}
    onClick={onClick}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={width}
    height={height}
    style={{ ...style }}
    bgOpacity={opacity}
    shadow={shadow}
    borderColor={borderColor}
    data-testid={testId}
  >
    <g clipPath="url(#clip0_19256_2672)">
      <path
        d="M17.5098 3.8701L15.7298 2.1001L5.83984 12.0001L15.7398 21.9001L17.5098 20.1301L9.37984 12.0001L17.5098 3.8701V3.8701Z"
        fill={color}
      />
    </g>
    <defs>
      <clipPath id="clip0_19256_2672">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </Svg>
);
